import PageSection from './PageSection';

export { PageSection };
export default PageSection;
